// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';

// ANTD
import Modal from 'antd/lib/modal';

// APOLLO
import { graphql, compose } from 'react-apollo';
import contactFormEntryFragment from 'ApolloClient/Fragments/contactFormEntryFragment';
import contactFormEntriesByClientIdQuery from 'ApolloClient/Queries/contactFormEntriesByClientId';
// COMPONENTS
import ContactFormEntriesTable from './ContactFormEntriesTable';
import SectionRow from 'components/common/SectionRow';
import SectionHeader from 'components/text/SectionHeader';
// LIB
import GeneralHelpers from 'lib/helpers/GeneralHelpers';
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';

export class ClientContactFormEntries extends React.Component {
  state = {
    visible: false,
    selected: null,
  };

  handleCancel = () => {
    this.setState({
      visible: false,
      selected: null,
    });
  };

  handleClick = record => {
    this.setState({
      visible: true,
      selected: record,
    });
  };

  render() {
    const { error, loading, contactFormEntriesByClientId } = this.props.contactFormEntriesByClientIdQuery;
    const { visible, selected } = this.state;

    if (error) {
      console.log(error);
      return <span>Something went wrong :(</span>;
    }

    if (loading) {
      return <span>Loading...</span>;
    }

    return (
      <SectionRow>
        <SectionHeader>CONTACT FORM ENTRIES</SectionHeader>
        <ContactFormEntriesTable onClick={this.handleClick} contactFormEntries={contactFormEntriesByClientId} />
        <Modal title="CONTACT FOR ENTRY" visible={visible} onCancel={this.handleCancel} footer={null}>
          <div>
            {selected &&
              Object.keys(selected).map(key => {
                let value = selected[key];
                if (key === 'createdAt') {
                  value = GeneralHelpers.formatDate(selected[key]);
                }
                if (key === '__typename') {
                  return null;
                }
                return (
                  <p key={key} style={{ fontSize: 17, color: '#999' }}>
                    <span style={{ fontWeight: 700, color: '#000' }}>{key}: </span>
                    {value}
                  </p>
                );
              })}
          </div>
        </Modal>
      </SectionRow>
    );
  }
}

ClientContactFormEntries.propTypes = {
  clientId: PropTypes.string.isRequired, // eslint-disable-line
  data: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    contactFormEntries: PropTypes.arrayOf(propType(contactFormEntryFragment)),
  }).isRequired,
};

const options = props => ({ variables: { clientId: props.clientId } });

export default compose(
  graphql(contactFormEntriesByClientIdQuery, { name: 'contactFormEntriesByClientIdQuery', options }),
  RecomposeHelpers.errorHOC({ propName: 'contactFormEntriesByClientIdQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'contactFormEntriesByClientIdQuery' }),
)(ClientContactFormEntries);



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientContactFormEntries/index.js